export const colorCollection = [
	["#F1634F", "#F68429", "#E3B505", "#53A93F", "#3E90C1", "#6D58B4", "#DD91EF", "#353535"],
	["#FACBC4", "#FCDCC2", "#FEF1C1", "#D6EED1", "#CFE3EF", "#D9D3EB", "#EEC7F7", "#DFDFDF"],
	["#F48575", "#F9AD70", "#FCDE6D", "#9FD793", "#8EBEDB", "#A598D1", "#E2A2F2", "#B5B5B5"],
	["#D11A00", "#CF5C00", "#D6A900", "#40A629", "#2678A9", "#4C31A4", "#9802BB", "#606060"],
	["#8A1B0B", "#8F4306", "#927403", "#356C28", "#245471", "#3B2E67", "#6D1382", "#4A4A4A"],
	["#621308", "#663004", "#685302", "#264D1D", "#1A3C50", "#2A2149", "#480058", "#1F1F1F"],
];
